
export class GeofencePointDto {
    public latitude: number;
    public longitude: number;
}
